import { SITE_ACTIONS } from '../constants/site-actions'
import { useBackToTop } from '../hooks/useBackToTop'
import '../styles/site-actions.scss'

export function SiteActions() {
  const { visible, scrollToTop } = useBackToTop()

  return (
    <div className="site-actions">
      {visible ? (
        <button
          type="button"
          className="site-actions__top"
          aria-label={SITE_ACTIONS.backToTop}
          onClick={scrollToTop}
        >
          <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden>
            <path
              fill="currentColor"
              d="M12 6.5 4.5 14l1.4 1.4L12 9.3l6.1 6.1 1.4-1.4z"
            />
          </svg>
        </button>
      ) : null}
      <a
        className="site-actions__whatsapp"
        href={SITE_ACTIONS.whatsappHref}
        target="_blank"
        rel="noreferrer"
        aria-label={SITE_ACTIONS.whatsappLabel}
        title={SITE_ACTIONS.whatsappLabel}
      >
        <img
          src={SITE_ACTIONS.whatsappIcon}
          alt=""
          width={SITE_ACTIONS.iconSize}
          height={SITE_ACTIONS.iconSize}
        />
      </a>
    </div>
  )
}
